import { colors } from '../../Colors/colors'

export const listsTheme = {
   light: {
      createList: {
         listHeading: 'text-gray-900',
         description: 'text-gray-600',
         arrowNarrowIconColor: colors['base-white'],
         closeIconColor: colors['gray-500']
      }
   },
   dark: {}
}
